export default class Tool
{
  constructor(name, notes, photoPath, attributes, removedAttributes) 
  {
    this.name = name;
    this.notes = notes;
    this.photoPath = photoPath;
    this.attributes = attributes;
    this.removedAttributes = removedAttributes;
  }    

  isValid()
  {
    var result = Boolean(this.name);

    if(result)
    {
      this.attributes.every(function(attribute, index) {
        result = attribute.isValid();

        return result;
      })
    }

    return result;
  }
}